import {$qsAll} from '../../../../@shared/ts/dom';
import {type ModalPage, type LoadingMode} from '../../models/IEnvironment';
import {DefaultCart} from '../../reducers/cartReducer';
import {Environment} from '../../reducers/environmentReducer';
import {PaymentConfiguration} from '../../reducers/paymentConfigurationReducer';
import {store} from '../../store';
import {formatCurrencyString} from '../../util/currency';
import {getLocaleText} from '../../util/translation';

export function setupConvesioPayButton() {
	store.subscribe(() => {
		renderConvesioPayButtonDisplay(
			PaymentConfiguration.selectedGateway(),
			Environment.modalUI.page(),
			Environment.modalUI.loadingMode(),
		);

		renderConvesioPayButtonLoading(
			Environment.modalUI.loadingMode(),
		);
	});
}

/**
 * Renders the ConvesioPay button display state.
 */
function renderConvesioPayButtonDisplay(gatewayId: string, page: ModalPage, loadingMode: LoadingMode) {
	// Show/hide ConvesioPay button container
	if (gatewayId.startsWith('peachpay_convesiopay_') && page === 'payment') {
		$qsAll('.convesiopay-btn-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.convesiopay-btn-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Hide/Show button
	if (loadingMode === 'loading') {
		$qsAll('.convesiopay-btn', $element => {
			$element.classList.add('hide');
		});
	} else {
		$qsAll('.convesiopay-btn', $element => {
			$element.classList.remove('hide');
		});
	}
}

/**
 * Renders the ConvesioPay button loading state.
 */
function renderConvesioPayButtonLoading(mode: LoadingMode) {
	// Show/hide the external spinner
	if (mode === 'loading') {
		$qsAll('.convesiopay-spinner-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.convesiopay-spinner-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide the internal spinner
	if (mode === 'processing') {
		$qsAll('.convesiopay-btn-spinner', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.convesiopay-btn-spinner', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide processing message
	if (mode === 'processing') {
		$qsAll('.convesiopay-btn > .button-text', $element => {
			$element.innerHTML = getLocaleText('Processing');
		});
	} else {
		$qsAll('.convesiopay-btn > .button-text', $element => {
			$element.innerHTML = `${getLocaleText('Pay')} ${formatCurrencyString(DefaultCart.total())}`;
		});
	}

	// Enable/disable the ConvesioPay button
	// Enable when not loading/processing and we're on the payment page with ConvesioPay selected
	const shouldEnable = mode !== 'loading' && mode !== 'processing';
	if (shouldEnable) {
		$qsAll<HTMLButtonElement>('.convesiopay-btn', $element => {
			$element.disabled = false;
		});
	} else {
		$qsAll<HTMLButtonElement>('.convesiopay-btn', $element => {
			$element.disabled = true;
		});
	}
}
